// Generated by ts-to-zod
import { z } from 'zod';

export const patchHookInterfacePayloadSchema = z.object({
  name: z.string(),
  description: z.string(),
  payload: z.record(z.unknown()),
  metadata: z.record(z.unknown()),
  type: z.string(),
});
